"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kpiAlertDialogMobileAlignPoints = exports.kpiAlertDialogAlignPoints = void 0;
exports.kpiAlertDialogAlignPoints = [
    {
        align: "tr tl",
        offset: {
            x: 18,
            y: 0,
        },
    },
    {
        align: "tl tr",
        offset: {
            x: -18,
            y: 0,
        },
    },
    {
        align: "br bl",
        offset: {
            x: 18,
            y: 0,
        },
    },
    {
        align: "bl br",
        offset: {
            x: -18,
            y: 0,
        },
    },
    {
        align: "bc tc",
        offset: {
            x: 0,
            y: 18,
        },
    },
    {
        align: "cc cr",
        offset: {
            x: -200,
            y: 0,
        },
    },
];
exports.kpiAlertDialogMobileAlignPoints = [
    {
        align: "bc tc",
        offset: {
            x: 0,
            y: 18,
        },
    },
    {
        align: "bl tl",
        offset: {
            x: 0,
            y: 18,
        },
    },
    {
        align: "br tr",
        offset: {
            x: 0,
            y: 18,
        },
    },
    {
        align: "tc bc",
        offset: {
            x: 0,
            y: -18,
        },
    },
    {
        align: "tl bl",
        offset: {
            x: 0,
            y: -18,
        },
    },
    {
        align: "tr br",
        offset: {
            x: 0,
            y: -18,
        },
    },
    {
        align: "cc tc",
        offset: {
            x: 0,
            y: 0,
        },
    },
    {
        align: "cl tl",
        offset: {
            x: 0,
            y: 0,
        },
    },
    {
        align: "cr tr",
        offset: {
            x: 0,
            y: 0,
        },
    },
];
//# sourceMappingURL=alignPoints.js.map